// extracted by mini-css-extract-plugin
module.exports = {"base":"fourCollection12Stories-m__base__2DrOj"};